import {useMemo} from "react";
import isEmpty from "lodash/isEmpty";

const useReservationInputsMainButton = (
    isReservationsDisabled,
    tooLate,
    offline,
    proposal,
    calculatedPriceForOffline,
    isInstantBookingEnabled,
    passeportEscales,
    handlers
) => useMemo(() => {
    if(isReservationsDisabled) {
        return null;
    }

    if(!tooLate && !offline) {
        if(!proposal && !calculatedPriceForOffline) {
            if (isInstantBookingEnabled) {
                return ({
                    mode: 'CHECK_AVAILABILITY',
                    handler: handlers.checkAvailability
                });
            } else {
                return ({
                    mode: 'ESTIMATE_PRICE',
                    handler: handlers.estimatePrice
                });
            }
        }
        if(proposal && (proposal.available_berths === null || proposal.available_berths > 0) && !isEmpty(proposal.price)) {
            return ({
                mode: 'CONTINUE_TO_BOOKING',
                handler: handlers.continueToBooking
            });
        }
    }
    if(((((tooLate || offline) && proposal) || (proposal && (proposal.available_berths === 0 || isEmpty(proposal.price)))))
        || ((!isInstantBookingEnabled || passeportEscales) && calculatedPriceForOffline)) {
        return ({
            mode: 'SEND_A_BOOKING_REQUEST',
            handler: handlers.sendBookingRequest
        });
    }
    return null;
}, [
    isReservationsDisabled,
    tooLate,
    offline,
    proposal,
    calculatedPriceForOffline,
    isInstantBookingEnabled,
    passeportEscales,
    handlers
]);

export default useReservationInputsMainButton;
